
import React from 'react';
import MetricCard from './MetricCard';

const MetricsGrid: React.FC = () => {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
      <MetricCard 
        title="Total Outstanding Debt" 
        value="₹752.4M" 
        subtext="+2.5% from last month" 
      />
      <MetricCard 
        title="Compliance Score" 
        value="96%" 
        subtext="+3% from last quarter" 
        valueClassName="text-2xl font-bold text-compliance-600" 
      />
      <MetricCard 
        title="Upcoming Repayments" 
        value="₹18.7M" 
        subtext="Due in next 30 days" 
      />
      <MetricCard 
        title="Pending Tasks" 
        value="12" 
        subtext="4 high priority" 
      />
    </div>
  );
};

export default MetricsGrid;
